export class ComplainantActa {
    get id() {
        return this.complainantActaState.id;
    }
    get diligenceNumber() {
        return this.complainantActaState.diligenceNumber;
    }
    get complainantThirId() {
        return this.complainantActaState.complainantThirId;
    }
    get lawId() {
        return this.complainantActaState.lawId;
    }
    get articleId() {
        return this.complainantActaState.articleId;
    }
    get intervenedMaterial() {
        return this.complainantActaState.intervenedMaterial;
    }
    get userId() {
        return this.complainantActaState.userId;
    }
    set diligenceNumber(diligenceNumber) {
        this.complainantActaState.diligenceNumber = diligenceNumber;
    }
    set complainantThirId(complainantThirId) {
        this.complainantActaState.complainantThirId = complainantThirId;
    }
    set lawId(lawId) {
        this.complainantActaState.lawId = lawId;
    }
    set articleId(articleId) {
        this.complainantActaState.articleId = articleId;
    }
    set intervenedMaterial(intervenedMaterial) {
        this.complainantActaState.intervenedMaterial = intervenedMaterial;
    }
    set userId(userId) {
        this.complainantActaState.userId = userId;
    }
    constructor(complainantActaState) {
        this.complainantActaState = complainantActaState;
    }
    getState() {
        return this.complainantActaState;
    }
}
